// prettier-ignore
import curricula from './curricula';
import reports from './reports';
import {
	program_progressReports,
	district_progressReports,
	district_usageReports,
	school_progressReports,
	school_usageReports,
} from './reports';
import toolkits from './toolkits';
import { anyone, nonStudent } from './access_defs';
import prependAcFn from './prependAcFn';

const rules = {
	noAccessFn: () => (false),
	fns: {
		page: {
			...prependAcFn(nonStudent, {
				...reports,
				...toolkits,
			}),
			'login': anyone,
			'': nonStudent, //home page
			'create-assignment': nonStudent, // redirect
			'gql': anyone,
			'403': anyone,
			'404': anyone,
			'500': anyone,
		},
		curriculum: curricula,
		feature: {
			'program/progressReports': program_progressReports,
			'district/progressReports': district_progressReports,
			'district/usageReports': district_usageReports,
			'school/progressReports': school_progressReports,
			'school/usageReports': school_usageReports,
		},
	},
	get ids(){
		if(!this._ids){
			this._ids = new Map();
			[this.noAccessFn].concat(
				Object.values(this.fns).flatMap(action => Object.values(action))
			).forEach(
				(fn) => this._ids.has(fn) || this._ids.set(fn, `ac_fn_${this._ids.size}`)
			);
		}
		return this._ids;
	},
	get(action, object){
		const fn = (this.fns[action] ?? {})[object] ?? this.noAccessFn;
		return [fn, this.ids.get(fn)];
	}
};
export default rules;
